import dynamic from 'next/dynamic';
const LinkInfoCard = dynamic(() => import('./LinkInfoCard'));
const LinkInfoItem = dynamic(() => import('./LinkInfoItem/LinkInfoItem'));

export { LinkInfoCard };
export { LinkInfoItem };
